export default {
  elements: {},
  init() {
    this.elements.parent = $('#anchor-menu');
    if (this.elements.parent.length > 0) {
      // ANCHOR MENU CREATOR
      $('#content h2').each(function(){
        $(this).attr('id', this.innerText);
      });

      var h2 = document.querySelectorAll("#content h2");

      var cList = $('ul.anchor-menu');
      $.each(h2, function(i)
      {
        var li = $('<li/>')
        .addClass('ui-menu-item')
        .appendTo(cList);
        var aaa = $('<a/>')
        .addClass('ui-all')
        .attr('href', "#"+h2[i].innerText)
        .text(h2[i].innerText)
        .appendTo(li);
      });

      // STICKY
      window.onscroll = function() {
        anchorScrollDetector()
      };
      var anchormenu = document.getElementById("anchor-menu");

      function anchorScrollDetector() {
        var newheight = (400 - window.pageYOffset);
        var windowwidth = window.innerWidth;

        if (windowwidth >= 992) {
          if (newheight >= 30) {
            $('#anchor-menu').css('top', newheight + 'px');
          }
        } else {
          $('#anchor-menu').css('top', '0px');
        }
      }

      var special_id ;
      // MENU HIGHLIGH
      $('#anchor-menu a').on('click', function(e) {
        $(this).parent().find('a').removeClass('active');
        $(this).addClass('active');
      });

      $(window).on('scroll', function() {
        $('h2').each(function() {
          if($(window).scrollTop() >= $(this).offset().top-50) {
            special_id = $(this).attr('id');
            $('#anchor-menu a').removeClass('active');
            $('#anchor-menu a[href="#'+ special_id +'"]').addClass('active');
          }
        });
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/components/anchormenu.js